import { combineReducers } from 'redux';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { editReducer, expoReducer } from './CrmReduxCalls/EditNavCtrl';
import { localdataReducer } from './CrmReduxCalls/LocalDataReduxStore';

const rootReducers = combineReducers({
  auth: authReducer,
  ChangeLayoutMode,
  edit: editReducer,
  localRedux: localdataReducer,
  explosion: expoReducer,
});

export default rootReducers;
